/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import moment from 'moment';
import { Typography } from '@material-ui/core';
import CustomToolbar from '../../../components/common/CustomToolbar/CustomToolbar';
import globals from '../../../globals/communityGlobals';
import { auditActionType } from '../../../settings/other';
import _ from '../../../utils/lodash';
import { formatNhs } from '../../../utils/helpers';

const locale = globals.getAreas(['patients', 'error']);
const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = ['AuditActionType', 'Forename', 'Surname', 'NhsNumber', 'DateOfChange'];
  const dtoNames = ['auditActionType', 'forename', 'surname', 'nhsNumber', 'dateOfChange'];

  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }

  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

const mapRowData = (rowData, options) => {
  const result =
    options.auditType === 1
      ? {
          id: rowData[0],
          errorMessage: rowData[1],
          createdBy: rowData[2],
          dateCreated: rowData[3],
        }
      : {
          id: rowData[0],
          fullName: `${rowData[2]} ${rowData[3]}`,
          eventName: rowData[1],
          dateOfChange: rowData[5],
        };
  options.eventHandlers.handleSidePanel(result, options.auditType === 0);
};

export const tableSettings = options => {
  let columns = [];
  if (options.auditType === 1) {
    columns = [
      {
        name: 'id',
        label: 'Id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        options: {
          sortOrder: {
            name: 'errorMessage',
            direction: setSortDirection('errorMessage', options),
          },
        },
      },
      {
        name: 'createdBy',
        label: 'Created By',
        options: {
          sortOrder: {
            name: 'createdBy',
            direction: setSortDirection('createdBy', options),
          },
          customBodyRender: value => (value === 'MessageQueue' ? 'External Provider' : value),
        },
      },
      {
        name: 'dateCreated',
        label: 'Date Created',
        options: {
          sortOrder: {
            name: 'dateCreated',
            direction: setSortDirection('dateCreated', options),
          },
          empty: true,
          customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
        },
      },
    ];
  } else {
    columns = [
      {
        name: 'id',
        label: 'Id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'auditActionType',
        label: locale.getMsg('auditActionTypeHeading'),
        options: {
          sortOrder: {
            name: 'auditActionType',
            direction: setSortDirection('auditActionType', options),
          },
          empty: true,
          customBodyRender: value => (auditActionType[value] ? auditActionType[value] : value),
        },
      },
      {
        name: 'forename',
        label: locale.getMsg('forenameHeading'),
        options: {
          sortOrder: {
            name: 'forename',
            direction: setSortDirection('forename', options),
          },
        },
      },
      {
        name: 'surname',
        label: locale.getMsg('surnameHeading'),
        options: {
          sortOrder: {
            name: 'surname',
            direction: setSortDirection('surname', options),
          },
        },
      },
      {
        name: 'nhsNumber',
        label: locale.getMsg('nhsNumberHeading'),
        options: {
          sortOrder: {
            name: 'nhsNumber',
            direction: setSortDirection('nhsNumber', options),
          },
          customBodyRender: value => (value ? formatNhs(value) : '-'),
        },
      },
      {
        name: 'dateOfChange',
        label: locale.getMsg('dateOfChange'),
        options: {
          sortOrder: {
            name: 'dateOfChange',
            direction: setSortDirection('dateOfChange', options),
          },
          empty: true,
          customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
        },
      },
    ];
  }
  return {
    name: <Typography variant="h3">{locale.getMsg('searchResults')}</Typography>,
    columns,
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 15, 30, 50, 100],
      rowsPerPage: options.pageSize,
      print: true,
      search: false,
      filter: false,
      serverSide: true,
      count: options.count,
      page: options.page,
      onRowClick: rowData => mapRowData(rowData, options),
      customToolbar: () => (
        <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isTableDataLoading} />
      ),
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
          case 'changeRowsPerPage':
            options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
            break;
          case 'sort':
            let sortColumn = '';
            let sortDirection = '';

            if (tableState.activeColumn > -1) {
              sortColumn = mapPropName(tableState.sortOrder.name);
              sortDirection = tableState.sortOrder.direction;
              options.eventHandlers.updateTableSort(sortColumn, sortDirection);
            }
            break;
        }
      },
    },
  };
};
